<template>
  <div class="side_float">
    <dl @click="toggleForm">
      <dt>
        <figure>
          <img src="../assets/img2/side_icon3.svg" loading="lazy" />
        </figure>
        <b>留言</b>
      </dt>
    </dl>
    <div class="form" v-if="isFormVisible">
      <h4 style="color: #ffa727">留言</h4>
      <div class="colse" @click="toggleForm">
        <img src="../assets/img2/colseBtn.jpg" alt="" loading="lazy" />
      </div>
      <div>
        <form class="form-horizontal" role="form" @submit.prevent="submitMsg">
          <div class="form-item">
            <label for="name">姓名</label>
            <div class="form-input col-xs-12">
              <input
                type="text"
                class="form-control"
                id="name"
                placeholder="请输入名字"
                v-model="name"
                required
              />
            </div>
          </div>
          <div class="form-item">
            <label for="email">邮箱</label>
            <div class="form-input col-xs-12">
              <input
                type="text"
                class="form-control"
                id="email"
                placeholder="请输入邮箱"
                v-model="email"
              />
            </div>
          </div>
          <div class="form-item">
            <label for="tel">电话</label>
            <div class="form-input col-xs-12">
              <input
                type="text"
                class="form-control"
                id="tel"
                placeholder="请输入电话"
                v-model="mobile"
                required
              />
            </div>
          </div>
          <div class="form-item">
            <label for="content">内容</label>
            <div class="form-input col-xs-12">
              <textarea
                class="form-control"
                id="content"
                rows="8"
                placeholder="请输入内容"
                v-model="content"
                required
              ></textarea>
            </div>
          </div>
          <div class="form-btn">
            <div>
              <button type="submit" class="btn btn-default btn-block">
                提交
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { putOnline } from "@/api/api";
export default {
  name: "SideTools",
  data() {
    return {
      isFormVisible: false,
      name: '',
      email: '',
      mobile: '',
      content: ''
    };
  },
  methods: {
    toggleForm() {
      this.isFormVisible = !this.isFormVisible;
    },
    submitMsg() {
      if (!this.name || !this.mobile || !this.content) {
        alert('姓名、电话和内容为必填项');
        return;
      }
      if (this.email && !this.validateEmail(this.email)) {
        alert('请输入有效的邮箱地址');
        return;
      }
      const payload = {
        name: this.name,
        email: this.email,
        mobile: this.mobile,
        content: this.content
      };
      // 发送请求的示例
      putOnline(payload).then((response) => {
        if (response.data.code == 200) {
          // 清空表单
          this.name = '';
          this.email = '';
          this.mobile = '';
          this.content = '';
          this.isFormVisible = false;
          alert(response.data.message)

        } else {
          alert(response.data.message || '提交失败')
        }
      })
      .catch((error) => {
        alert('Error:', error);
      });
    },
    validateEmail(email) {
      const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return re.test(email);
    }
  }
};
</script>

<style scoped>
.side_float {
  position: fixed;
  right: 1%;
  top: 36%;
  transform: translateY(-50%);
  z-index: 20;
}
.side_float dl {
  position: relative;
}
.side_float dt figure {
  width: 20px;
  height: 20px;
  padding: 0;
}
.side_float dl:hover dt {
  background: #ffa727;
  opacity: 1;
}
.side_float dl:hover dt,
.side_float dl:hover dt b {
  color: #fff;
}
.side_float dl:hover dt img {
  filter: brightness(0) invert(1);
}
img {
  border: none;
  max-width: 100%;
  height: 100%;
  vertical-align: middle;
}
.side_float dl:not(:last-child) {
  margin-bottom: 10px;
}
.side_float dt {
  position: relative;
  z-index: 10;
  cursor: pointer;
  width: 45px;
  height: 45px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  border-radius: 5px;
  text-align: center;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  opacity: 0.7;
}
.side_float dd .box {
  font-size: 16px;
  line-height: 2;
  color: #333333;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  padding: 30px;
  min-width: 240px;
  background: #fff;
}
.side_float .closeBtn {
  position: absolute;
  top: 20px;
  right: 30px;
  height: 17px;
  width: 17px;
  display: block;
  /* background: url(../images/colseBtn.jpg) no-repeat; */
}
.form {
  position: absolute;
  right: 60px;
  top: 200px;
  transform: translateY(-50%);
  font-size: 16px;
  line-height: 2;
  color: #333333;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  padding: 30px;
  width: 400px;
  background: #fff;
}
.colse {
  width: 17px;
  height: 17px;
  position: absolute;
  top: 14px;
  right: 14px;
  cursor: pointer;
}
.close img {
  width: 100%;
  height: 100%;
}
.form-control {
  margin: 10px 0;
}
.form-item {
  display: flex;
  align-items: center;
}
.form-input {
  flex: 1;
}
.form-btn {
  margin: 10px 14px 0 48px;
}
</style>



// WEBPACK FOOTER //
// src/components/SideTools.vue